// Path: src\Components\More\More.jsx
import React, { useState } from "react";
import BaseHome from "../Home/BaseHome";
import premiumImg from "../../assets/images/more/icon_premium.svg";
import JoinViaInviteCodeImg from "../../assets/images/more/icon_join_via_invite_code.svg";
import leaderboard from "../../assets/images/more/icon_leaderboard.svg";
import dailyloginreward from "../../assets/images/more/icon_daily_login_reward.svg";
import applypromocode from "../../assets/images/more/icon_apply_promo.svg";
import vipoints from "../../assets/images/more/icon_vi_points.svg";
import customercare from "../../assets/images/more/icon_customer_care.svg";
import legality from "../../assets/images/more/icon_legality.svg";
import favgame from "../../assets/images/more/icon_favourites.svg";
import languageimg from "../../assets/images/more/Global_language.svg";
import JoinViaInviteCodePopup from "../Popup/More/InviteCodePopup";
import PromoCodePopup from "../Popup/More/PromoCodePopup";
import { useNavigate } from 'react-router-dom';
import Favourite from "./Favourite";
import LaguegueSelection from "./LaguegueSelection";
import { routesFrontend } from "../RouterFiles/routes";
import { t } from "i18next";
import { claimedRewards, claimRewards, dailyRewardsList } from "../../api/rewards.api";
import CoinsClaimedPopup from "../Popup/CoinsClaimedPopup";
import SpinTheWheelPopup from "../Popup/SpinTheWheel";
import { url } from "../../config/url";
const KEY = process.env.ENCRYPT_KEY

var CryptoJS = require("crypto-js");

const More = () => {
  const navigate = useNavigate();
  const [dailyRewards, setDailyRewards] = useState([]);
  const [wonReward, setWonReward] = useState(null);
  const [isSpinTheWheelPopup, setisSpinTheWheelPopup] = useState(false);
  const [isCoinsClaimedPopup, setisCoinsClaimedPopup] = useState(false);

  const [isLegalityOpen, setIsLegalityOpen] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const [isJoinViaInviteCode, setisJoinViaInviteCode] = useState(false);
  const [isPromocode, setisPromocode] = useState(false);

  const [isFavouriteOpen, setIsFavouriteOpen] = useState(false)
  const [isLanguageOpen, setIsLanguageOpen] = useState(false)

  const toggleLegalityMenu = () => {
    setIsLegalityOpen(!isLegalityOpen);
    setSelectedMenuItem("legality"); // Mark legality as selected
  };
  const fetchClaimedReward = async () => {
    try {
      console.log(url.ENCRYPT_KEY)
      var response = await claimedRewards();
      if (response && response?.success && response?.data) {
        setWonReward(response?.data)
        setisCoinsClaimedPopup(true)
      }else{
        fetchLoginRewards();
      }
    } catch (error) { }
  }
  const onRewardWin = (reward) => {
    claimDailyLoginReward(reward);
  }
  const claimDailyLoginReward = async (reward) => {
    try {
      var _id = CryptoJS.AES.encrypt(reward?._id, url.ENCRYPT_KEY).toString()
      const res = await claimRewards({ reward: _id });
      setisSpinTheWheelPopup(false)
      if (res?.success && reward?.rewardAmount > 0) {
        setWonReward(reward);
        setisCoinsClaimedPopup(true)
      }
    } catch (error) {
    }
  };
  const fetchLoginRewards = async () => {
    try {
      const res = await dailyRewardsList({pagination:{pageNo:1,recordPerPage:10,sortBy:"order",}});
      if (res?.success && res?.data && res?.claimReward===false) {
        setDailyRewards(res?.data)
        setisSpinTheWheelPopup(true)
      }
      else {
        setDailyRewards([]);
      }
    } catch (error) {
    }
  };

  const handleMenuItemClick = (menuItem) => {
    setSelectedMenuItem(menuItem);
    if (menuItem === "premium") {
      navigate('/more/subscription-pack')
    }
    if (menuItem === "dailyLoginReward") {
      if(wonReward==null) fetchClaimedReward(); else setisCoinsClaimedPopup(true)
      return; // return is because if condition match then we doesn;t required to match any other conditions
    }

    if (menuItem === "viPoints") {
      navigate('/more/vipoints')
    }

    if (menuItem !== "legality") {
      setIsLegalityOpen(false); // Close legality submenu if other item is clicked
    }
    if (menuItem === "joinViaInviteCode") {
      setisJoinViaInviteCode(true);
    } else {
      setisJoinViaInviteCode(false);
    }
    if (menuItem === "favGame") {
      setIsFavouriteOpen(true);
    } else {
      setIsFavouriteOpen(false);
    }

    if (menuItem === "language") {
      setIsLanguageOpen(true);
    } else {
      setIsLanguageOpen(false);
    }
    if (menuItem === "leaderboard") {
      navigate(routesFrontend.leaderboard)
    }
    if (menuItem === "customerCare") {
      navigate(routesFrontend.customerCare)
    }


    if (menuItem === "applyPromoCode") {
      setisPromocode(true);
    } else {
      setisPromocode(false);
    }
  };


  return (
    <BaseHome title={t("moreMenu.title_more")} isFooter={true} isMore={true} notBack={true}>
      <div className="sub-container-bodyscroll">
        <div className="moremenuitems-container">
          <div
            className={`moremenuitems-item-premium ${selectedMenuItem === "premium" ? "selected" : ""
              }`}
            onClick={() => handleMenuItemClick("premium")}
          >
            <div className="moremenu-dflex">
              <img
                src={premiumImg}
                alt={t("moreMenu.premium")}
                className="moremenuitems-icon moremenuitems-icon-v2"
              />
              <span>{t("moreMenu.premium")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "joinViaInviteCode" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("joinViaInviteCode")}
          >
            <div className="moremenu-dflex">
              <img
                src={JoinViaInviteCodeImg}
                alt={t("moreMenu.title_join_via_invite_code")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.title_join_via_invite_code")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "leaderboard" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("leaderboard")}
          >
            <div className="moremenu-dflex">
              <img
                src={leaderboard}
                alt={t("moreMenu.leaderboard")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.leaderboard")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "dailyLoginReward" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("dailyLoginReward")}
          >
            <div className="moremenu-dflex">
              <img
                src={dailyloginreward}
                alt={t("moreMenu.daily_login_rewards")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.daily_login_rewards")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "applyPromoCode" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("applyPromoCode")}
          >
            <div className="moremenu-dflex">
              <img
                src={applypromocode}
                alt={t("moreMenu.apply_promo_code")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.apply_promo_code")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "viPoints" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("viPoints")}
          >
            <div className="moremenu-dflex">
              <img
                src={vipoints}
                alt={t("moreMenu.vi_points")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.vi_points")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          <div
            className={`moremenuitems-item ${selectedMenuItem === "customerCare" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("customerCare")}
          >
            <div className="moremenu-dflex">
              <img
                src={customercare}
                alt={t("moreMenu.customer_care")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.customer_care")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          {/* Expandable Legality Section */}
          <div
            className={`moremenuitems-item moremenuitems-legality ${selectedMenuItem === "legality" ? "selected" : ""
              }`}
            onClick={toggleLegalityMenu}
          >
            <div className="moremenu-dflex">
              <img
                src={legality}
                alt={t("moreMenu.legality")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.legality")}</span>
            </div>
            <span
              className={`moremenuitems-arrow ${isLegalityOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16 7L21 12M21 12L16 17M21 12L3 12"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                "moremenuitems-arrow-right"
              )
                }`}
            >
              {isLegalityOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17 16L12 21M12 21L7 16M12 21V3"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16 7L21 12M21 12L16 17M21 12L3 12"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
            </span>
          </div>

          {/* Expanded Legality Section */}
          {isLegalityOpen && (
            <div className="moremenuitems-submenu">
              <div className="moremenuitems-subitem" onClick={() => navigate("/more/terms-of-use")}>{t("moreMenu.term_of_use")}</div>
              <div className="moremenuitems-subitem" onClick={() => navigate("/more/privacy-policy")}>{t("moreMenu.privacy_policy")}</div>
            </div>
          )}

          <div
            className={`moremenuitems-item ${selectedMenuItem === "favGame" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("favGame")}
          >
            <div className="moremenu-dflex" >
              <img
                src={favgame}
                alt={t("moreMenu.favourite_game")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.favourite_game")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>

          {/* <div
            className={`moremenuitems-item ${selectedMenuItem === "language" ? "" : ""
              }`}
            onClick={() => handleMenuItemClick("language")}
          >
            <div className="moremenu-dflex">
              <img
                src={languageimg}
                alt={t("moreMenu.language")}
                className="moremenuitems-icon"
              />
              <span>{t("moreMenu.language")}</span>
            </div>
            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div> */}

          {/* <div className="moremenuitems-item">
            <span>{t("moreMenu.logout")}</span>

            <span className="moremenuitems-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 7L21 12M21 12L16 17M21 12L3 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div> */}
        </div>
        {isJoinViaInviteCode && (
          <JoinViaInviteCodePopup
            isOpen={isJoinViaInviteCode}
            title={t("moreMenu.title_join_via_invite_code")}
            onClose={() => setisJoinViaInviteCode(false)}
          />
        )}
        {isFavouriteOpen && (
          <Favourite
            isOpen={isFavouriteOpen}
            title={t("moreMenu.title_select_your_fav_game")}
            onClose={() => setIsFavouriteOpen(false)}
          />
        )}
        {isLanguageOpen && (
          <LaguegueSelection
            isOpen={isLanguageOpen}
            title={t("moreMenu.title_select_language")}
            onClose={() => setIsLanguageOpen(false)}
          />
        )}
        {isPromocode && (
          <PromoCodePopup
            isOpen={isPromocode}
            title={t("promo_code.promo_code")}
            onClose={() => setisPromocode(false)}
          />
        )}
        {isSpinTheWheelPopup && (
          <SpinTheWheelPopup
            isOpen={isSpinTheWheelPopup}
            title="spin the wheel"
            data={dailyRewards}
            onClose={() => setisSpinTheWheelPopup(false)}
            onRewardWin={onRewardWin}
          />
        )}
        {isCoinsClaimedPopup && (
          <CoinsClaimedPopup
            isOpen={isCoinsClaimedPopup}
            title="500"
            reward={wonReward}
            onClose={() => setisCoinsClaimedPopup(false)}
          />
        )}
      </div>
    </BaseHome>
  );
};

export default More;
